import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_DOMESTICBANK,
  GET_DOMESTICBANKS_BY_USERNAME,
} from "./actionTypes"

import {

  getDomesticBankListSuccess,
  getPayFacCommissionBankListByUserNameSuccess,
  domesticBankApiError

} from "./actions"

//Include Both Helper File with needed methods
import {
  getDomesticBankList,
  getPayFacCommissionBankListByUserName

} from "../../helpers/backend_helper/backend_helper"

function* onGetDomesticBankList({ payload: record }) {
  try {
    const response = yield call(getDomesticBankList, record)
    yield put(getDomesticBankListSuccess(response))
  } catch (error) {
    yield put(domesticBankApiError(error))
  }
}

function* onGetPayFacCommissionBankListByUserName({ payload: record }) {
  try {
    const response = yield call(getPayFacCommissionBankListByUserName, record)
    yield put(getPayFacCommissionBankListByUserNameSuccess(response))
  } catch (error) {
    yield put(domesticBankApiError(error))
  }
}

function* domesticBankManagementSaga() {

  yield takeEvery(GET_DOMESTICBANK, onGetDomesticBankList)
  yield takeEvery(GET_DOMESTICBANKS_BY_USERNAME, onGetPayFacCommissionBankListByUserName)
}

export default domesticBankManagementSaga
